import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";

const AdminSettingsHowTo = ({ onBack }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [data, setData] = useState({
    title: "",
    subtitle: "",
    intro_description: "",
    car_text: "",
    car_buttons: [],
    transport_text: "",
    transport_lines: [],
    train_text: "",
    train_lines: [],
    walking_text: "",
    map_iframe: "",
  });

  // UČITAVANJE PODATAKA
  useEffect(() => {
    const fetchData = async () => {
      const localData = localStorage.getItem("temp_how_to_come");

      const { data: dbData, error } = await supabase
        .from("how_to_come")
        .select("*")
        .single();

      if (localData) {
        setData(JSON.parse(localData));
      } else if (dbData && !error) {
        // Osiguravamo da liste budu nizovi čak i ako baza vrati null
        setData({
          ...dbData,
          car_buttons: dbData.car_buttons || [],
          transport_lines: dbData.transport_lines || [],
          train_lines: dbData.train_lines || [],
        });
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  // LOKALNO SPREMANJE (Auto-save dok editiraš)
  useEffect(() => {
    if (!loading) {
      localStorage.setItem("temp_how_to_come", JSON.stringify(data));
    }
  }, [data, loading]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  // POMOĆNE FUNKCIJE ZA LISTE
  const addItem = (listName, newItem) => {
    setData((prev) => ({
      ...prev,
      [listName]: [...(prev[listName] || []), { id: Date.now(), ...newItem }],
    }));
  };

  const removeItem = (listName, id) => {
    setData((prev) => ({
      ...prev,
      [listName]: prev[listName].filter((item) => item.id !== id),
    }));
  };

  const updateItem = (listName, idx, field, value) => {
    const newList = [...data[listName]];
    newList[idx][field] = value;
    setData({ ...data, [listName]: newList });
  };

  // SPREMANJE U BAZU
  const handleSave = async () => {
    setSaving(true);
    const { error } = await supabase
      .from("how_to_come")
      .update(data)
      .eq("id", 1);

    if (!error) {
      alert("Sve izmjene su spremljene u bazu!");
      localStorage.removeItem("temp_how_to_come");
      if (onBack) onBack();
    } else {
      alert("Greška pri spremanju!");
    }
    setSaving(false);
  };

  if (loading) return <div className="admin-loader">Učitavam postavke...</div>;

  return (
    <div className="admin-sub-page admin-howto-edit">
      {" "}
      <button className="back-btn" onClick={onBack}>
        <i className="fi fi-rs-arrow-left"></i> Natrag
      </button>
      <div className="admin-header-flex">
        <h3>Uredi Lokaciju i Prijevoz</h3>
      </div>
      <div className="admin-form-container">
        {/* NASLOVNA SEKCIJA */}
        <section className="admin-section">
          <label>Naslov stranice</label>
          <input name="title" value={data.title} onChange={handleChange} />

          <label>Podnaslov (ispod naslova)</label>
          <input
            name="subtitle"
            value={data.subtitle}
            onChange={handleChange}
          />

          <label>Dodatni uvodni opis (neobavezno)</label>
          <textarea
            name="intro_description"
            value={data.intro_description}
            onChange={handleChange}
          />
        </section>

        {/* AUTOMOBILOM */}
        <section className="admin-section">
          <h4>
            <i className="fi fi-rs-car"></i> Automobilom
          </h4>
          <label>Tekst opisa</label>
          <textarea
            name="car_text"
            value={data.car_text}
            onChange={handleChange}
          />

          <div className="dynamic-list">
            <label>Gumbi (npr. Parking + Google Maps link)</label>
            {data.car_buttons?.map((btn, idx) => (
              <div key={btn.id} className="dynamic-row">
                <input
                  placeholder="Naziv gumba"
                  value={btn.label}
                  onChange={(e) =>
                    updateItem("car_buttons", idx, "label", e.target.value)
                  }
                />
                <input
                  placeholder="Link (Google Maps)"
                  value={btn.link}
                  onChange={(e) =>
                    updateItem("car_buttons", idx, "link", e.target.value)
                  }
                />
                <button
                  className="delete-row"
                  onClick={() => removeItem("car_buttons", btn.id)}
                >
                  <i className="fi fi-rs-trash"></i>
                </button>
              </div>
            ))}
            <button
              className="add-btn-small"
              onClick={() => addItem("car_buttons", { label: "", link: "" })}
            >
              + Dodaj gumb
            </button>
          </div>
        </section>

        {/* ZET PRIJEVOZ */}
        <section className="admin-section">
          <h4>
            <i className="fi fi-rs-bus"></i> ZET Autobus / Tramvaj
          </h4>
          <label>Uvodni tekst</label>
          <input
            name="transport_text"
            value={data.transport_text}
            onChange={handleChange}
          />
          <div className="dynamic-list">
            {data.transport_lines?.map((line, idx) => (
              <div key={line.id} className="dynamic-row line-row">
                <input
                  className="small"
                  placeholder="Br."
                  value={line.num}
                  onChange={(e) =>
                    updateItem("transport_lines", idx, "num", e.target.value)
                  }
                />
                <input
                  placeholder="Polazak"
                  value={line.from}
                  onChange={(e) =>
                    updateItem("transport_lines", idx, "from", e.target.value)
                  }
                />
                <input
                  placeholder="Dolazak/Stanica"
                  value={line.to}
                  onChange={(e) =>
                    updateItem("transport_lines", idx, "to", e.target.value)
                  }
                />
                <button
                  className="delete-row"
                  onClick={() => removeItem("transport_lines", line.id)}
                >
                  <i className="fi fi-rs-trash"></i>
                </button>
              </div>
            ))}
            <button
              className="add-btn-small"
              onClick={() =>
                addItem("transport_lines", { num: "", from: "", to: "" })
              }
            >
              + Dodaj ZET liniju
            </button>
          </div>
        </section>

        {/* VLAK */}
        <section className="admin-section">
          <h4>
            <i className="fi fi-rs-train"></i> Vlak (HŽ)
          </h4>
          <label>Opis za vlak</label>
          <input
            name="train_text"
            value={data.train_text}
            onChange={handleChange}
          />
          <div className="dynamic-list">
            {data.train_lines?.map((line, idx) => (
              <div key={line.id} className="dynamic-row line-row">
                <input
                  placeholder="Linija (Zagreb - Podsused)"
                  value={line.name}
                  onChange={(e) =>
                    updateItem("train_lines", idx, "name", e.target.value)
                  }
                />
                <input
                  placeholder="Stanica"
                  value={line.station}
                  onChange={(e) =>
                    updateItem("train_lines", idx, "station", e.target.value)
                  }
                />
                <button
                  className="delete-row"
                  onClick={() => removeItem("train_lines", line.id)}
                >
                  <i className="fi fi-rs-trash"></i>
                </button>
              </div>
            ))}
            <button
              className="add-btn-small"
              onClick={() => addItem("train_lines", { name: "", station: "" })}
            >
              + Dodaj liniju vlaka
            </button>
          </div>
        </section>

        {/* BICIKL / PJESKE */}
        <section className="admin-section">
          <h4>
            <i className="fi fi-rs-walking"></i> Biciklom & Pješice
          </h4>
          <textarea
            name="walking_text"
            value={data.walking_text}
            onChange={handleChange}
          />
        </section>

        {/* GOOGLE MAPS */}
        <section className="admin-section">
          <h4>
            <i className="fi fi-rs-map"></i> Karta (Google Maps Iframe)
          </h4>
          <textarea
            name="map_iframe"
            value={data.map_iframe}
            onChange={handleChange}
            placeholder="Zalijepi <iframe ...> kod ovdje"
          />
        </section>

        <button
          className="main-admin-btn save-btn"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "SPREMANJE..." : "SPREMI SVE IZMJENE"}
        </button>
      </div>
    </div>
  );
};

export default AdminSettingsHowTo;
